import React from 'react';
import ReactDOM from 'react-dom/client';
import MainRoute from './MainRoute';
import axios from 'axios';
import 'antd/dist/antd.css';
import zh_TW from 'antd/es/locale/zh_TW';
import './theme'
import { ConfigProvider } from 'antd';
// axios.defaults.baseURL = 'http://10.0.4.131'  //連手機
// axios.defaults.baseURL = 'http://localhost:8081'  
axios.defaults.baseURL = 'https://ancient-classic-reading.nknu.edu.tw'  
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ConfigProvider locale={zh_TW}>
        <MainRoute />
    </ConfigProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
